module.exports = __webpack_public_path__ + "img/logo_bouygue_enterprise.216450e6.svg";